<template>
  <div class="join-us">
    <div class="fy-drawer" v-if="IsMobile">
      <div class="fy-drawer__logo">
        <img :src="ppjsIconM" />
      </div>
    </div>
    <ul class="products-image__list">
      <li v-for="(products, index) in productsList" :key="index" class="products-image__list_item">
        <div class="products-image__list_item_img">
          <router-link :to="`/products_detail?id=${products.id}&type=${products.type}&size=${(index & 1) === 0 ? 'horizontal' : 'vertical'}`">
            <img v-lazy="(index & 1) === 0 ? products.horizontalImg : products.verticalImg" />
            <div class="products-image__list_item_img_info">
              <div>{{(index & 1) === 0 ? products.horizontalName: products.name}}</div>
            </div>
          </router-link>
        </div>
        <div class="products-image__list_item_img">
          <router-link :to="`/products_detail?id=${products.id}&type=${products.type}&size=${(index & 1) === 0 ? 'vertical' : 'horizontal'}`">
            <img v-lazy="(index & 1) === 0 ? products.verticalImg : products.horizontalImg" />
            <div class="products-image__list_item_img_info">
              <div>{{(index & 1) === 0 ? products.name: products.horizontalName}}</div>
            </div>
          </router-link>
        </div>
      </li>
    </ul>
    <div class="fy-introduction" v-if="!IsMobile">
      <div class="fy-drawer">
        <div class="fy-drawer__logo">
          <img :src="ppjsIcon" />
        </div>
        <div class="fy-drawer__text">
        </div>
        <div class="fy-drawer__bottom">
          <img :src="drawerBottomIcon" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import { IsMobile } from "@/utils";
import dayjs from "dayjs";
import ppjsIcon from "@/assets/pphz—icon.png";
import ppjsIconM from "@/assets/pphz-iconM.png";
import drawerBottomIcon from "@/assets/drawer-bottom-icon@3x.png";
export default Vue.extend({
  name: "BrandCooperate",
  data() {
    return {
      productsList: [],
      IsMobile,
      ppjsIcon,
      ppjsIconM,
      drawerBottomIcon,
    };
  },
  created() {
    this.getList();
  },
  methods: {
    getList() {
      this.$https
        .get("/api/oilliProduct/getListForweb", {
          params: {
            type: "brand",
          },
        })
        .then((res) => {
          this.productsList = res.data.items;
        });
    },
    dayFormat(time) {
      return dayjs(time).format("YYYY.MM.DD");
    },
    productItemClick(type, name) {
      this.showDrawer = false;
      this.$router.push({
        path: "/products",
        query: {
          type,
          name,
        },
      });
    },
  },
});
</script>
